import { linkToAnonymousWhatIsPremium } from "../../links";

export function linkToAnonymousWhatIsPremiumParent() {
  return `${linkToAnonymousWhatIsPremium()}/parent`;
}
